import Vue from 'vue'
import Router from 'vue-router'
import Home from "@/views/Home.vue";
import Company from "@/views/Company.vue";
import Admin from "@/views/Admin.vue";
import Login from "@/views/Login.vue";
import CompanyAuthorisedSignatory from "@/views/CompanyAuthorisedSignatory.vue";

Vue.use(Router);

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: "/",
            name: "home",
            components: {
                default: Home,
            }
        },
        {
            path: "/company/:searchType?/:orgNo?",
            name: "company",
            components: {
                default: Company
            }
        },
        {
            path: "/company-authorised-signatory",
            name: "company-authorised-signatory",
            components: {
                default: CompanyAuthorisedSignatory
            }
        },
        {
            path: "/admin",
            name: "admin",
            components: {
                default: Admin
            }
        },
        {
            path: "/login",
            name: "login",
            components: {
                default: Login
            }
        },
        {
            path: "/logout",
            name: "logout",
            components: {
                default: Login
            }
        },
        {
            path: "/*",
            name: "missing",
            redirect: {name: "home"}
        }
    ]
})
